import { IAppState } from '../../../state';

export function userSelector(state: IAppState) {
  return state.user;
}
